module.exports = "<mat-sidenav-container>\n  <router-outlet></router-outlet>\n</mat-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/layouts/auth/auth-layout.component.html
// module id = ../../../../../src/app/layouts/auth/auth-layout.component.html
// module chunks = main